import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum SupervisedRightsFormErrorStatesEnum {
    AssignRightsFailed = ErrorStateScheduleEnum.AssignSupervisedRightsFormErrorStatesStartIndex,
    UpdateRightsFailed,
    DeleteRightsFailed
}
